"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemIdentifierSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.ItemIdentifierSchema = zod_1.z.object({
    type: zod_1.z.nativeEnum(__1.ItemIdentifierType),
    value: __1.ShortStringSchema.min(1),
});
//# sourceMappingURL=item-identifier.js.map